import CheckboxComponent from '@components/inputs/checkbox/Checkbox.component';
import NumberTextFieldComponent from '@components/inputs/numberTextField/NumberTextField.component';
import { Stack, Typography } from '@mui/material';
import {
  AiScheduleEnum,
  AuditOperationScheduleDto,
  CreateAuditOperation
} from '@store/audits/audits-operation/audits-operation.model';
import { getTypeOf } from '@utils/getTypeOf';
import { useEffect, useState } from 'react';

interface AuditContainerProps {
  auditOperation?: CreateAuditOperation;
  updateAuditOperation: <T extends keyof CreateAuditOperation>(
    field: T,
    value: CreateAuditOperation[T]
  ) => void;
}

const DailyCollect = (props: AuditContainerProps) => {
  const {
    auditOperation,
    updateAuditOperation
  } = props;


  const [isEveryDay, setIsEveryDay] = useState<boolean>(false);
  const [isEveryNumberDay, setIsEveryNumberDay] = useState<boolean>(false);
  const [frequency, setFrequency] = useState<AuditOperationScheduleDto>();
  const [nbDay, setNbDay] = useState<number>();

  useEffect(() => {
    if (auditOperation) {
      if (auditOperation.schedule) {
        const frequencyobj = getTypeOf<AuditOperationScheduleDto>(auditOperation.schedule!);
        if (frequencyobj.dailyEveryWeekDay) {
          handleIsEveryDay();
        } else {
          handleIsEveryNumberDay();
        }
        setFrequency(frequencyobj);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auditOperation?.schedule]);



  function handleIsEveryDay() {
    setIsEveryDay(true);
    setIsEveryNumberDay(false);
    updateAuditOperation('frequency', {
      frequency: AiScheduleEnum.DAILY,
      dailyEveryWeekDay: true
    });
  }

  function handleIsEveryNumberDay() {
    setIsEveryDay(false);
    setIsEveryNumberDay(true);
    updateAuditOperation('frequency', {
      frequency: AiScheduleEnum.DAILY,
      dailyFrequencyNumber: frequency?.dailyFrequencyNumber ?? nbDay,
      dailyEveryWeekDay: false,
    });
  }

  function onchangeNumberDay(value: number) {
    updateAuditOperation('frequency', {
      frequency: AiScheduleEnum.DAILY,
      dailyFrequencyNumber: value
    });
    setNbDay(value);
  }

  return (
    <>
      <Stack pl="145px" spacing={2}>
        <Stack>
          <Stack direction="row" alignItems="center">
            <CheckboxComponent
                handleChange={handleIsEveryNumberDay}
                labelPlacement='end'
                label='Tous les'
                value={isEveryNumberDay}
            />
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <NumberTextFieldComponent
                inputWidth={80}
                pattern={new RegExp(/^(\d*|\d+)$/)}
                value={frequency?.dailyFrequencyNumber || 0}
                handleChange={(value) => { onchangeNumberDay(value!); }}
              />
              <Typography fontSize={14} fontWeight="400">
                jour(s)
              </Typography>
            </Stack>
          </Stack>
        </Stack>
        <Stack direction="row" alignItems="center">
          <CheckboxComponent
              handleChange={handleIsEveryDay}
              labelPlacement='end'
              label='Tous les jours ouvrables'
              value={isEveryDay}
          />
        </Stack>
      </Stack>
    </>
  );
};

export default DailyCollect;